import LanguageSetting from './LanguageSetting';
import LogoutIcon from '@mui/icons-material/Logout';
import RoleSwitchSetting from './RoleSwitchSetting';
import ChangeCharacterSetting from './ChangeCharacterSetting';
import ManageSupervisorsSetting from './ManageSupervisorsSetting';
import ManageClientsSetting from './ManageClientsSetting';
import LegalSetting from './LegalSetting';
import AppearanceSettings from './AppearanceSettings';
import { BasicDialogContent } from '../utils/dialogs/BasicDialog';
import AISettings from './AISettings';
import ProfileSettings from './ProfileSettings';
import AccountSettings from './AccountSettings';

export type SettingsConfig = {
  id: string;
  title: string;
  titleColor?: string;
  // null = posten döljer sig själv (t.ex. AISettings utan AI-nyckel). Samma möjlighet
  // som toggleComponent nedan redan förutsätter — ChangeCharacterSetting gömmer sig när
  // barnläget är av.
  accordionContent?: () => JSX.Element | null;
  icon?: () => JSX.Element;
  hideAsSupervisor?: boolean;
  onlyAsSupervisor?: boolean;
  /**
   * Posten kräver en AI-nyckel i miljön. Utan nyckel svarar varje AI-anrop 500, och då
   * ska hela posten bort — inte bara innehållet, för en rubrik som öppnar en tom låda är
   * sämre än ingen rubrik. Se utils/ai.ts.
   */
  requiresAi?: boolean;
  dialog?: BasicDialogContent;
  accordionHeader?: (props: SettingsConfig) => JSX.Element;
  toggleComponent?: (props: SettingsConfig) => JSX.Element | null;
  disabled?: boolean;
};

export const settingsConfig: SettingsConfig[] = [
  {
    // Roll-växling nåbar ÄVEN i handledarläge (RoleSwitchSetting bor annars i
    // ProfileSettings som är hideAsSupervisor). Utan denna kan handledaren inte
    // byta tillbaka till sin egen dagsvy via UI.
    id: 'roleSwitch',
    title: 'Your role right now',
    toggleComponent: RoleSwitchSetting,
    onlyAsSupervisor: true,
  },
  {
    id: 'changeCharacter',
    title: 'child.settings.changeCharacter',
    toggleComponent: ChangeCharacterSetting, // self-hides när childMode är av
    hideAsSupervisor: true,
  },
  {
    id: 'profile',
    title: 'Profile',
    accordionContent: ProfileSettings,
    hideAsSupervisor: true,
  },
  {
    id: 'AISettings',
    title: 'AI Settings',
    accordionContent: AISettings,
    hideAsSupervisor: true,
    requiresAi: true,
  },
  {
    id: 'supervisorManagement',
    title: 'Manage supervisors',
    accordionContent: ManageSupervisorsSetting,
    hideAsSupervisor: true,
  },
  {
    id: 'clientManagement',
    title: 'Manage clients',
    accordionContent: ManageClientsSetting,
    onlyAsSupervisor: true,
  },
  {
    id: 'language',
    title: 'Language',
    accordionContent: LanguageSetting,
  },
  {
    id: 'PrivacyPolicyAndTermsOfService',
    title: 'Legal & Licenses',
    accordionContent: LegalSetting,
  },
  {
    id: 'appearance',
    title: 'settings.appearance',
    accordionContent: AppearanceSettings,
  },
  {
    // Borttagningen av kontot bor i en neutral, hopfälld rubrik i stället för som en
    // röd rad i listan — se AccountSettings för hela resonemanget.
    id: 'account',
    title: 'settings.account.title',
    accordionContent: AccountSettings,
  },
  {
    id: 'logout',
    title: 'Logout',
    icon: () => <LogoutIcon />,
    dialog: {
      title: 'Logout',
      body: 'Are you sure you want to logout?',
      confirmText: 'Logout',
      cancelText: 'No',
    },
  },
];
